import React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { Box, InputLabel, Typography, useTheme, useMediaQuery } from "@mui/material";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()(() => ({
    icon: {
        fill: "#eee",
    },
    main: {
        // backgroundColor: "transparent",
        // borderRadius: "10px",
        // minWidth: "50px",
        // ".MuiInputBase-input": {
        //     height: "10px",
        //     fontSize: "16px",
        // },
        // ".MuiInputBase-formControl:hover .MuiOutlinedInput-notchedOutline": {
        //     borderColor: `#c4c4c4 !important`,
        // },
        // ".MuiOutlinedInput-notchedOutline": {
        //     borderColor: `#c4c4c4 !important`,
        //     borderRadius: "10px",
        // },
        // ".Mui-focused .MuiOutlinedInput-notchedOutline": {
        //     borderColor: `#c4c4c4 !important`,
        //     borderWidth: "1px !important",
        // },
        // "& .MuiInputBase-formControl.Mui-disabled": {
        //     backgroundColor: "transparent",
        //     borderRadius: "10px",
        //     opacity: 0.8,
        // },
        // "& .MuiOutlinedInput-root": {
        //     padding: "5px !important"
        // }
    },
    error: {
        border: "1px solid red",
    },
}));

export default function AutoCompleteSearch(props) {
    const {
        width,
        text,
        valid,
        options,
        placeholder,
        handleChange,
        name,
        onBlur,
        searchValue,
        handleSearch,
        multiple = false,
        fullWidth,
        className,
        fontSize,
        color,
        renderOption,
        getOptionLabel,
        startAdornment,
        disabled = false,
        defaultValue,
        blurOnSelect,
        fontWeight,
        labelSize,
        labelColor,
        whiteSpace,
        subText
    } = props;

    const { classes, cx } = useStyles();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    return (
        <>
            {text && (
                <Box mb={0.5} display="flex" fontSize="12px" flexDirection={"row"}>
                    <Box display="flex" fontSize="12px" flexDirection={"column"} flexWrap={"wrap"} >
                        <InputLabel
                            sx={{
                                letterSpacing: "0.03em",
                                marginRight: "2px",
                                fontWeight: fontWeight,
                                fontSize: labelSize || "14px",
                                color: labelColor || "#222222",
                                whiteSpace: whiteSpace ? "wrap" : "nowrap",
                            }}
                        >
                            {text}
                        </InputLabel>
                        {subText && <InputLabel
                            sx={{
                                letterSpacing: "0.03em",
                                marginRight: "2px",
                                fontWeight: fontWeight,
                                fontSize: "11px",
                                color: labelColor || "#222222",
                                whiteSpace: whiteSpace ? "wrap" : "nowrap",
                            }}
                        >
                            {subText}
                        </InputLabel>}
                    </Box>
                    {valid && (
                        <Typography color="#EF627A" component={"span"} variant={"body2"}>
                            *
                        </Typography>
                    )}
                </Box>
            )}
            <Box display="flex">
                <Autocomplete
                    fullWidth={fullWidth}
                    multiple={multiple}
                    className={cx(classes.main, className)}
                    disabled={disabled}
                    renderOption={renderOption}
                    blurOnSelect={blurOnSelect}
                    options={options || []}
                    onChange={handleChange}
                    isOptionEqualToValue={(option, value) => value === "" || value === option}
                    value={defaultValue || null}
                    defaultValue={defaultValue || ""}
                    size="small"
                    
                    sx={{
                        width: isMobile ? "100%" : width,
                        backgroundColor: "white",
                        marginLeft: isMobile ? "10px" : "auto",
                    }}
                    renderInput={(params) => (
                        <TextField
                            className="searchInput"
                            {...params}
                            onBlur={onBlur}
                            placeholder={placeholder}
                            onChange={handleSearch}
                            name={name}
                            disabled={disabled}
                            value={searchValue}
                            variant="standard"
                            InputProps={{
                                ...params.InputProps,
                                startAdornment: isMobile ? null : startAdornment,
                            }}
                        />
                    )}
                    getOptionLabel={getOptionLabel}
                />
            </Box>
        </>
    );
}
